import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledCardItem = styled.div<{ $size?: number }>`
    display: flex;
    flex-direction: column;
    grid-column: span ${({ $size }) => $size || "1"};

    @media ${breakpoints.xs} {
        grid-column: span 3;
    }

    span,
    li {
        font-size: var(--size-14);
        color: var(--color-grey-900);
    }

    span:first-child {
        font-size: var(--size-14);
        color: var(--color-grey-800);
    }
`;

export const StyledCardList = styled.div`
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(3, 1fr);
`;
